const rates = {
  createRateBtn: 'Crear',
  showBreakdownBtn: 'Mostrar desglose',
  total: 'Total: ',

  table: {
    headers: {
      name: 'Nombre',
      code: 'Código',
      supplierName: 'Proveedor',
      isActive: 'Estado',
      isAvailable: 'Disponible',
      biDir: 'Bidireccional',
    },
    filters: {
      code: 'Código',
      supplier: 'Proveedor',
      profile: 'Perfil',
      attributes: 'Atributos',
      service: 'Servicio',
    },
    cells: {
      isActive: {
        true: 'Activo',
        false: 'Inactivo',
      },
      isAvailable: {
        true: 'SÍ',
        false: 'NO',
      },
    },
    biDirOptions: {
      way2: '2 Vías',
      way1: '1-Vía',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
  },

  deleteModal: {
    header: 'Eliminar tasas',
    body: 'Está a punto de eliminar {{num}} tasas.',
  },

  rateTypeOptions: {
    Base: 'Base',
    Addition: 'Adición',
    Percent: 'Porcentaje',
    Total: 'Total',
  },

  additions: {
    value: 'Valor',
    valueType: 'Tipo de valor',
    name: 'Nombre',
    hour1: 'Hora de inicio',
    hour2: 'Hora de finalización',
    date1: 'Fecha de inicio',
    date2: 'Fecha de finalización',
    cancel: 'Cancelar',
    addAddition: 'Añadir suma',
    priority: 'Prioridad',
    weekDays: 'Días de la semana',
    newAddition: 'Nueva incorporación',
    price: 'Precio',
    total: 'Total',
    percent: 'Porcentaje',
    columnExist: 'El título ya existe',
  },

  toast: {
    error: {
      badResponse: '[Ubicación] respuesta incorrecta del servidor',
    },
  },

  create: {
    successToast: {
      message: '¡Éxito! Tasa de creación',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear la tarifa',
    },
  },

  edit: {
    successToast: {
      message: '¡Éxito! Tasa actualizada',
    },

    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar la tasa',
    },

    modalError: {
      header: 'Error.',
      body: 'No se puede actualizar la tasa.',
    },
  },

  delete: {
    successToast: {
      message: '[Tasas] se eliminaron correctamente',
    },

    errorToast: {
      message: '[Tasas] mala respuesta del servidor',
    },
  },

  forms: {
    header: {
      createRate: {
        title: 'Crear',
      },

      updateRate: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles de la Tarifa',
        fields: {
          units: {
            name: 'Sites',
          },
          from: {
            name: 'From',
          },
          to: {
            name: 'To',
          },
          supplierId: {
            name: 'Proveedor',
          },
          servicesIds: {
            name: 'Servicio',
          },
          profilesIds: {
            name: 'Perfil',
          },
          biDirectional: {
            name: 'Bidireccional',
          },
          group: {
            name: 'Rate Group',
          },
          name: {
            name: 'Nombre',
          },
        },
      },
    },
    type: {
      header: 'Rate Type',
      fields: {
        fromAreasIds: 'Desde el zona',
        toAreasIds: 'Hacia el zona',
        biDirectional: 'Bidireccional',
        basePrice: 'Precio Base',
        durationFactors: {
          baseDuration: 'Duración Base',
          pricePerAdditional: {
            value: 'Por Minuto Adicional',
            type: {
              fixed: 'Fijo',
              percentage: 'Porcentaje (Desde Base)',
            },
          },
        },
        distanceFactors: {
          baseDistance: 'Distancia Base',
          pricePerAdditional: {
            value: 'Por KM/Milla Adicional',
            type: {
              fixed: 'Fijo',
              percentage: 'Porcentaje (Desde Base)',
            },
          },
        },
      },
      addBtn: 'Agregar',
    },
    availability: {
      header: 'Disponibilidad de Tarifa',
      fields: {
        from: 'Disponible Desde',
        to: 'Disponible Hasta',
        fromTime: 'Hora Desde',
        toTime: 'Hora Hasta',
        weekDays: 'Días Laborales',
      },
      addBtn: 'Agregar Disponibilidad',
    },

    addition: {
      header: 'Adiciones Generales',
      fields: {
        stops: {
          included: 'Paradas Incluidas',
          pricePerAddition: {
            value: 'Por Parada Adicional',
            type: {
              fixed: 'Fijo',
              percentage: 'Porcentaje (Desde Base)',
            },
          },
        },
        seats: {
          included: 'Asientos Incluidos',
          pricePerAddition: {
            value: 'Por Asiento Adicional',
            type: {
              fixed: 'Fijo',
              percentage: 'Porcentaje (Desde Base)',
            },
          },
        },
      },
    },
    peakHoursSurcharge: {
      header: 'Recargo por Horas Pico',
      fields: {
        name: 'Nombre',
        fromTime: 'Desde',
        toTime: 'Hasta',
        priceAddition: {
          value: 'Adición de Precio',
          type: {
            fixed: 'Fijo',
            percentage: 'Porcentaje (Desde Base)',
          },
        },
        weekDays: 'Días Laborales',
      },
      addBtn: 'Agregar Recargo por Horas Pico',
    },

    geoAdditions: {
      generalAreaEntrance: {
        header: 'Entrada General a la Zona',
        fields: {
          pricePerArea: 'Precio por Zona',
          chargingMethod: {
            name: 'Método de Cobro',
            options: {
              drivingThrough: 'Paso por la Zona',
              stops: 'Paradas',
            },
          },
          type: {
            fixed: 'Fijo',
            percentage: 'Porcentaje (Desde Base)',
          },
        },
      },
      specificAreaEntrance: {
        header: 'Entrada a Zona Específica',
        fields: {
          areasIds: 'Zona',
          pricePerArea: 'Precio por Zona',
          chargingMethod: {
            name: 'Método de Cobro',
            options: {
              drivingThrough: 'Paso por la Zona',
              stops: 'Paradas',
            },
          },
          type: {
            fixed: 'Fijo',
            percentage: 'Porcentaje (Desde Base)',
          },
        },
        addBtn: 'Agregar Zona',
      },
    },
  },
};

export default rates;
